import { Input, Form, Button, message } from "antd";
import TextArea from "antd/es/input/TextArea";
import React, { useEffect, useState } from "react";

const Photographer_detail = () => {
  const [studio_name, setname] = useState('');
  const [phone_no, setphone] = useState('');
  const [email, setEmail] = useState('');
  const [description, setdescription] = useState('');
  const [exist, setexist] = useState(false);
  const [studioData, setstudiodata] = useState({});
  const [editMode, setEditMode] = useState(false);
  const [refresh, setRefresh] = useState(0);

  useEffect(() => {
    const fetchStudio = async () => {
      let user = JSON.parse(localStorage.getItem('user'));
      const create_by = user._id;

      try {
        const resp = await fetch(`http://localhost:5000/exist-studio?create_by=${create_by}`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' }
        });

        const result = await resp.json();

        if (resp.ok) {
          setstudiodata(result.exist);
          setexist(true);
          // Preload values if not in edit mode
          if (!editMode) {
            setname(result.exist.studio_name || '');
            setphone(result.exist.phone_no || '');
            setEmail(result.exist.email || '');
            setdescription(result.exist.description || '');
          }
        }
      } catch (error) {
        message.error('An unexpected error occurred');
      }
    };

    fetchStudio();
  }, [refresh]);

  const handleform = async (e) => {
    e.preventDefault();

    if (!studio_name || !phone_no || !email) {
      message.error("Please fill in all required fields including email.");
      return;
    }

    let user = JSON.parse(localStorage.getItem('user'));
    const create_by = user._id;

    const resp = await fetch('http://localhost:5000/studio', {
      method: "POST",
      body: JSON.stringify({ studio_name, phone_no, email, description, create_by }),
      headers: { 'Content-Type': 'application/json' }
    });

    const result = await resp.json();

    if (resp.ok) {
      message.success(result.message);
      setEditMode(false); // ✅ Exit edit mode
      setRefresh(prev => prev + 1); // ✅ Trigger refresh
    } else {
      message.error(result.message);
    }
  };

  const handleEdit = () => {
    setEditMode((prev) => !prev);
    setname(studioData.studio_name || '');
    setphone(studioData.phone_no || '');
    setEmail(studioData.email || '');
    setdescription(studioData.description || '');
  };

  return (
    <div className="">
      {exist ? (
        <div>
          <h3>Photographer's Details</h3>
          {!editMode ? (
            <div className="p-4 m-4">
              <p><strong>Name:</strong> {studioData.studio_name}</p>
              <p><strong>Contact Number:</strong> {studioData.phone_no}</p>
              <p><strong>Email:</strong> {studioData.email}</p>
              <p><strong>Description:</strong> {studioData.description}</p>
              <Button type="primary" onClick={handleEdit}>Edit</Button>
            </div>
          ) : (
            <div className="p-4 m-4">
              <Form onSubmitCapture={handleform}>
                <Input
                  type="text"
                  value={studio_name}
                  onChange={(e) => setname(e.target.value)}
                  placeholder="Enter Your Name"
                />
                <Input
                  type="number"
                  value={phone_no}
                  onChange={(e) => setphone(e.target.value)}
                  maxLength={13}
                  placeholder="Enter Your Contact No."
                />
                <Input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter Your Email"
                />
                <TextArea
                  value={description}
                  onChange={(e) => setdescription(e.target.value)}
                  placeholder="Best Line for the Guest to Impress and Hire You"
                />
                <br />
                <Button htmlType="submit" type="primary">Save Changes</Button>
                <Button style={{ marginLeft: 10 }} onClick={() => setEditMode(false)}>Cancel</Button>
              </Form>
            </div>
          )}
        </div>
      ) : (
        <div>
          <h3>Photographer's Profile</h3>
          <div className="p-4 m-4">
            <Form onSubmitCapture={handleform}>
              <Input
                type="text"
                value={studio_name}
                onChange={(e) => setname(e.target.value)}
                placeholder="Enter Your Name"
              />
              <Input
                type="number"
                value={phone_no}
                onChange={(e) => setphone(e.target.value)}
                maxLength={13}
                placeholder="Enter Your Contact No. "
              />
              <Input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="Enter Your Email"
              />
              <TextArea
                value={description}
                onChange={(e) => setdescription(e.target.value)}
                placeholder="Best Line for the Guest to Impress and Hire You"
              />
              <br />
              <Button htmlType="submit" type="primary">Submit</Button>
            </Form>
          </div>
        </div>
      )}
    </div>
  );
};

export default Photographer_detail;
